// extracted by mini-css-extract-plugin
export default {"row":"returnChips_row__BCoVA","chip":"returnChips_chip__kz8OL"};